import { Component, OnInit } from '@angular/core';
import { LoggedinService } from '../../services/login/loggedin.service';
import { Router } from '@angular/router';
import { SessionHelper } from '../../shared/services/localstorage';
import {Menus} from '../../models/menus/menus';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  menu: Menus;
  user: any;
  public _pageTitle: string;
  public get pageTitle() {
    return this._pageTitle;
  };
  
  public set pageTitle(value: string) {
    this._pageTitle = value;
  };

  public logout() {
    SessionHelper.logout();
    this.loggedInService.changeStatus(false);
    this.router.navigate(['login']);
  }
  

  constructor(private loggedInService: LoggedinService, private router: Router) {
    this.pageTitle = this.loggedInService.getCurrentPageTitle();
    console.log(this.pageTitle)
    this.menu = new Menus();
   }

  ngOnInit() {
    console.log(this.router.url);
    this.user = SessionHelper.getSession();
    this.getPageTitle(this.router.url);
    this.pageTitle = this.loggedInService.getCurrentPageTitle();
    console.log(this.pageTitle)
    if (this.router) {
      this.router.events.subscribe((event: any) => {
        // console.log(event);
        if (event) {
          if (event.url) {
            this.getPageTitle(event.url);            
          }
        }
      });
    }
  }

  getPageTitle(url) {

    if (url.indexOf('/dashboard') > -1) {
      this.pageTitle = 'Dashboard';
    } else if (url.indexOf('event/create') > -1) {
      this.pageTitle = 'Create Event';
    } else if (url.indexOf('profile') > -1) {
      this.pageTitle = 'My Profile';
    } else if (url.indexOf('/event/details') > -1) {
      this.pageTitle = 'Event Details';
    } else if (url.indexOf('calendar') > -1) {
      this.pageTitle = 'My Events';
    } else if (url.indexOf('/my-events/list') > -1) {
      this.pageTitle = 'My Events';
    }  else if (url.indexOf('/speaker/list') > -1) {
      this.pageTitle = 'Search Patient Speaker';
    } else if (url.indexOf('/speaker/create') > -1) {
      this.pageTitle = 'Create Patient Speaker';
    } else if (url.indexOf('/speaker-content') > -1) {
      this.pageTitle = 'Manage Speaker Content';
    } else if (url.indexOf('/speaker/edit') > -1) {
      this.pageTitle = 'Edit Patient Speaker Profile';
    } else if (url.indexOf('/speaker/details') > -1) {
      this.pageTitle = 'View Patient Speaker Profile';
    } else if (url.indexOf('/view-speaker-profile') > -1) {
      this.pageTitle = 'View Patient Speaker Profile';
    } else if (url.indexOf('/speaker') > -1) {
      this.pageTitle = 'Assign Speaker Content';
    } else if (url.indexOf('/training') > -1 || url.indexOf('/initiatetraining') > -1) {
      this.pageTitle = 'Training';
    } else if (url.indexOf('/upload-reference') > -1) {
      this.pageTitle = 'Reference Materials';
    } else if (url.indexOf('/venue/list') > -1) {
      this.pageTitle = 'Venue';
    } else if (url.indexOf('/venue/create') > -1) {
      this.pageTitle = 'Create Venue';
    } else if (url.indexOf('/venue/details') > -1) {
      this.pageTitle = 'Venue Details';
    }  else if (url.indexOf('/venue/edit') > -1) {
      this.pageTitle = 'Edit Venue';
    } else if (url.indexOf('/attendee-list') > -1) {
      this.pageTitle = 'Attendee List';
    } else if (url.indexOf('/reports') > -1) {
      this.pageTitle = 'Reports';
    } else if (url.indexOf('/reconcile-event') > -1) {
      this.pageTitle = 'Reconcile Program';
    } else if (url.indexOf('/myprofile') > -1) {
      this.pageTitle = 'My Profile';
    } else if (url.indexOf('/upcoming-programs-filter') > -1) {
      this.pageTitle = 'Upcoming Programs';
    } else if (url.indexOf('/task-filter') > -1) {
      this.pageTitle = 'Tasks';
    } else if (url.indexOf('/notification-filter') > -1) {
      this.pageTitle = 'Notifications';
    }

    this.loggedInService.setCurrentPageTitle(this.pageTitle);
  }

}
